/**
 * Interface for communicating shop information to the Unity WebGL app.
 */
interface IShopInfo {
  domain: string;
  shopFolder?: string;
  token: string;
  cdn?: string;
}

export default IShopInfo;
